import React from "react";
import PropTypes from "prop-types";
import ReactQuill from "react-quill";
import { makeStyles } from "tss-react/mui";
import "react-quill/dist/quill.snow.css";

const useStyles = makeStyles()((theme) => ({
	quill: {},
	colorPicker: {
    "& .ql-picker-options": {
      width: "5px !important",
      padding: "4px !important",
    },
  },
}));

const TextEditor = ({
	id,
	onChange,
	theme,
	placeholder,
	value,
	name,
	readOnly,
	onBlur,
	onKeyDown,
	withColors = false,
}) => {
	const { classes, cx } = useStyles();

	const baseToolbar = [
		[{ header: "1" }, { header: "2" }],
		[{ size: [] }],
		["bold", "italic", "underline", "strike", "blockquote"],
   ];

	if (withColors) {
		baseToolbar.push([{ color: ["rgb(255, 0, 0)", "rgb(0, 0, 0)"] }]);
	}

	const modules = {
    toolbar: baseToolbar,
    clipboard: {
      matchVisual: false,
    },
  };

  const formats = [
    "header",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    ...(withColors ? ["color"] : []),
  ];

	return (
		<div>
			<ReactQuill
				preserveWhitespace={true}
				id={id}
				name={name}
				value={value}
				onChange={onChange}
				theme={theme}
				placeholder={placeholder}
				// modules={TextEditor.modules}
				// formats={TextEditor.formats}
				modules={modules}
      		    formats={formats}
				readOnly={readOnly}
				onBlur={onBlur}
				onKeyDown={onKeyDown}
				// className={classes.quill}
				// className={cx(classes.quill, classes.colorPicker)}
				className={cx(classes.quill, withColors && classes.colorPicker)}
			></ReactQuill>
		</div>
	);
};

TextEditor.defaultProps = {
	theme: "snow",
	readOnly: false,
	onChange: () => {},
	withColors: false,
};

TextEditor.propTypes = {
	onChange: PropTypes.func,
	placeholder: PropTypes.string,
	theme: PropTypes.string,
	style: PropTypes.object,
	value: PropTypes.string,
	name: PropTypes.string,
	readOnly: PropTypes.bool,
	onBlur: PropTypes.func,
	withColors: PropTypes.bool,
};

// TextEditor.modules = {
// 	toolbar: [
// 		[{ header: "1" }, { header: "2" }],
// 		[{ size: [] }],
// 		["bold", "italic", "underline", "strike", "blockquote"],
// 		[{ color: ["#ff0000","#000000"] }],
// 	],
// 	clipboard: {
// 		// toggle to add extra line breaks when pasting HTML:
// 		matchVisual: false,
// 	},
// };

// TextEditor.formats = [
// 	"header",
// 	"size",
// 	"bold",
// 	"italic",
// 	"underline",
// 	"strike",
// 	"blockquote",
// 	"color",
// ];

export default TextEditor;
